import { useGLTF, RoundedBox, Text } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import { COLORS } from "../../constants/colors";
import SurfaceButtonOpenSN from "../surfacebuttons/SurfaceButtonOpenSN.jsx";
import { BUTTON_IDS } from "../../stores/useGame";
import PointerShadow from "../pointers/PointerShadow.jsx";
import { MODELS } from "../loader/models.js";

const Telegram = ({ position = [0, 0, 0] }) => {
  const { scene } = useGLTF(MODELS.TELEGRAM);

  return (
    <group position={position}>
      <Text
        fontSize={0.9}
        color={"white"}
        rotation-x={-Math.PI / 2}
        position={[-4, -0.99, -8]}
      >
        #MessageReplier
      </Text>
      <primitive
        scale={1.2}
        position-y={1}
        rotation-x={-Math.PI / 4}
        rotation-y={-Math.PI / 4}
        rotation-z={-Math.PI / 5}
        object={scene}
      />
      <PointerShadow width={15} height={15} opacity={0.5} softness={0.8} />
      <RigidBody type="fixed" colliders="cuboid" ccd={false}>
        <RoundedBox args={[4, 1, 4]} radius={0.01} position-y={-0.99}>
          <meshStandardMaterial color={COLORS.surfaceElements} />
        </RoundedBox>
      </RigidBody>
      <SurfaceButtonOpenSN
        position={[0, -0.98, 5]}
        buttonId={BUTTON_IDS.TELEGRAM}
        width={2}
        height={1.5}
      />
    </group>
  );
};

export default Telegram;
